import cn from "classnames";
import { ChangeEvent, FC } from "react";
import styles from "./SubnetCalculator.module.css";
import { getDataAutomationGroup } from "@/helpers";
import { MinusThick, PlusThick } from "@/icons";

interface MaskBitsInputProps {
  maskBits: number;
  setMaskBits: (value: number) => void;
  subnetBits: number;
}

export const MaskBitsInput: FC<MaskBitsInputProps> = ({
  maskBits,
  setMaskBits,
  subnetBits,
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const number = parseInt(e.target.value);
    setMaskBits(number);
  };

  const handleBlur = () => {
    if (isNaN(maskBits)) setMaskBits(0);
    if (maskBits > 32 - subnetBits) {
      setMaskBits(32 - subnetBits);
    }
  };

  const handleIncrement = () => {
    if (maskBits < 32 - subnetBits) {
      setMaskBits(maskBits + 1);
    }
  };

  const handleDecrement = () => {
    if (maskBits > 0) {
      setMaskBits(maskBits - 1);
    }
  };

  const handleKeyDownDecrement = (
    e: React.KeyboardEvent<HTMLButtonElement>,
  ) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleDecrement();
    }
  };

  const handleKeyDownIncrement = (
    e: React.KeyboardEvent<HTMLButtonElement>,
  ) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleIncrement();
    }
  };

  return (
    <div className={cn("relative flex flex-col", styles.calc)}>
      <label
        className="text-body-xs text-swdc-gray-400 pb-2 font-bold"
        htmlFor="mask-bits"
      >
        Mask bits
      </label>
      <input
        className="border-swdc-gray-200 text-swdc-gray-400 focus:outline-swdc-black-600 rounded-button h-10 w-full border-2 bg-white px-12 text-center md:w-48"
        id="mask-bits"
        type="number"
        inputMode="numeric"
        min={0}
        max={32 - subnetBits}
        value={maskBits}
        onChange={handleChange}
        onBlur={handleBlur}
        onWheel={(e) => e.target instanceof HTMLElement && e.target.blur()}
        {...getDataAutomationGroup("input-field")}
      />
      <button
        className="text-swdc-black-600 hover:text-swdc-gray-300 focus-visible:text-swdc-gray-300 focus-visible:outline-swdc-blue-400 active:text-swdc-black-600 absolute bottom-0 left-5 h-10 px-1.5 focus-visible:outline-2"
        onClick={handleDecrement}
        onKeyDown={handleKeyDownDecrement}
        aria-label="Decrement mask bits"
      >
        <MinusThick fill="currentColor" width={16} aria-hidden />
      </button>
      <button
        className="text-swdc-black-600 hover:text-swdc-gray-300 focus-visible:text-swdc-gray-300 focus-visible:outline-swdc-blue-400 active:text-swdc-black-600 absolute right-5 bottom-0 h-10 px-1.5 focus-visible:outline-2"
        onClick={handleIncrement}
        onKeyDown={handleKeyDownIncrement}
        aria-label="Increment mask bits"
      >
        <PlusThick fill="currentColor" width={16} aria-hidden />
      </button>
    </div>
  );
};
